// Lib
import { useEffect } from 'react';
import PropTypes from 'prop-types';

// Utils
import { DOM_POINTER_TYPES } from '../../../../utils/domConstants';

// Styles
import './DrawingEditorToolbarIPadPenTools.scss';

const DrawingEditorToolbarIPadPenTools = (props) => {
    const { isPenMode, setIsPenMode } = props;

    useEffect(() => {
        const onPointerMove = (e) => {
            if (e.pointerType !== DOM_POINTER_TYPES.PEN) return;

            setIsPenMode(true);
        };

        document.addEventListener('pointermove', onPointerMove);

        return () => {
            document.removeEventListener('pointermove', onPointerMove);
        };
    }, [isPenMode]);

    return null;
};

DrawingEditorToolbarIPadPenTools.propTypes = {
    toolMode: PropTypes.string,
    isPenMode: PropTypes.bool,
    setIsPenMode: PropTypes.func,
};

export default DrawingEditorToolbarIPadPenTools;
